import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AnalyticsData } from '../../../domain/qualification';
import { DataLoadState, ErrorType, initialDataLoadState } from '../../../store/reducers/common';

type AnalyticsDataState = DataLoadState;

const initialState: AnalyticsDataState = { ...initialDataLoadState };

const slice = createSlice({
  name: 'analyticsData',
  initialState,
  reducers: {
    loadAnalyticsData: (state) => ({
      ...state,
      loading: true,
    }),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadAnalyticsDataSuccess: (state, _payload: PayloadAction<AnalyticsData>) => ({
      ...state,
      loading: false,
    }),
    loadAnalyticsDataFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
  },
});

const {
  reducer: analyticsReducer,
  actions: { loadAnalyticsData, loadAnalyticsDataSuccess, loadAnalyticsDataFail },
} = slice;

type SendTQC05Payload = {
  testimonialPanelExperiment: string;
};

const sendTQC05 = createAction<SendTQC05Payload>('analyticsData/sendTQC05');

export {
  sendTQC05,
  analyticsReducer,
  loadAnalyticsData,
  loadAnalyticsDataFail,
  loadAnalyticsDataSuccess,
  type SendTQC05Payload,
};
